import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Company } from '../materials/companies';

export interface DailySupply {
    _id: string;
    activityId: string;
    designation: string;
    companyId: Company;
    quantity: number;
    unit: number;
    observations?: string;
    price?: number;
    orderNumber?: string;
    unitPrice?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface DailySuppliesResponse {
    message: string;
    data: DailySupply[];
}

export interface DailySupplyResponse {
    message: string;
    data: DailySupply;
}

export interface CreateDailySupplyBody {
    activityId: string;
    designation: string;
    companyId: string;
    quantity: number;
    unit: number;
    observations?: string;
    price?: number;
    unitPrice?: number;
    orderNumber?: string;
}

export interface UpdateDailySupplyBody {
    activityId?: string;
    designation?: string;
    quantity?: number;
    companyId?: string;
    unit?: number;
    observations?: string;
    price?: number | null;
    unitPrice?: number | null;
    orderNumber?: string;
}

export interface GetDailySuppliesQueries {
    activityId?: string;
}

// GET ALL
export const getAllDailySupplies = async (queries?: GetDailySuppliesQueries): Promise<DailySuppliesResponse> => {
    try {
        const response: AxiosResponse<DailySuppliesResponse> = await apiClient.get('/daily-supplies', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

// CREATE
export const createDailySupply = async (data: CreateDailySupplyBody): Promise<DailySupplyResponse> => {
    try {
        const response: AxiosResponse<DailySupplyResponse> = await apiClient.post('/daily-supplies', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

// UPDATE
export const updateDailySupply = async (id: string, data: UpdateDailySupplyBody): Promise<DailySupplyResponse> => {
    try {
        const response: AxiosResponse<DailySupplyResponse> = await apiClient.patch(`/daily-supplies/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

// DELETE
export const deleteDailySupply = async (id: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/daily-supplies/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};
